import { Paper } from './paper/paper'

//商品
export class Product{
    id : number = 0; //DBの中でのID
    name : string = ""; //商品名
    code : string = ""; //商品品番
    codeWeb : string = ""; //商品品番("51979-12P"の、"51979"の部分)
    imagePath : string = ""; //商品画像
    description : string = ""; //商品概要
    assortment : boolean = false; //アソート品フラグ(よく分からない) 複数の種類のpaperを持ってる商品かどうかかと思ったが違うよう
    region : string = ""; //国コード
    mobile : boolean = false; //モバイルフラグ
    paperList : Paper[] = [ new Paper() ]; //持ってる用紙の配列(種類で分ける) 基本的には一つの商品につき一種類の用紙なので配列の中身は一つ
    productCategoryId : number = 0; //どのプロダクトに所属してるか
    

    //↓元々はproductにselectedPaperを持たせたかった
    // _selectedPaper : Paper = new Paper();
    // set selectedPaper(paper : Paper){ this._selectedPaper = paper; };
    // get selectedPaper(){ return this._selectedPaper; };
    // selectPaper(paperId : number){
    //     alert(1)
    //     this.selectedPaper = Enumerable.asEnumerable(this.paperList).Where(x=>x.id==paperId).ToArray()[0]
    // }
}